import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { parseCallRateOverrideFromQuery } from '../utils/callRateOfferUtils';
import {
  CALL_MEDIA_TYPE,
  DEFAULT_CALL_UI_MEDIA_TYPE,
  getCallMediaTypeFromVoiceUi,
} from '../constant';

/**
 * URL/query state for the Matrix call screen (/call?roomId=…&callType=…).
 */
export function useCallRouteParams() {
  const location = useLocation();
  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const roomId = query.get('roomId') ?? null;
  const callType = (query.get('callType') || '').toLowerCase();
  const callUiType = (query.get('type') || DEFAULT_CALL_UI_MEDIA_TYPE).toLowerCase();
  const isVoiceCallUi = callUiType === CALL_MEDIA_TYPE.VOICE;
  const callMediaType = getCallMediaTypeFromVoiceUi(isVoiceCallUi);
  const shouldAutoPlaceCall = callType === 'outgoing';
  const isIncomingCallRoute = callType === 'incoming';
  const queryPricingModelRaw = (query.get('pricingModel') || '').toLowerCase();
  const callRateOverride = useMemo(() => {
    return parseCallRateOverrideFromQuery({
      query,
      queryPricingModelRaw,
      shouldAutoPlaceCall,
    });
  }, [query, queryPricingModelRaw, shouldAutoPlaceCall]);

  return {
    query,
    roomId,
    callType,
    callUiType,
    isVoiceCallUi,
    callMediaType,
    shouldAutoPlaceCall,
    isIncomingCallRoute,
    queryPricingModelRaw,
    callRateOverride,
  };
}
